export default __webpack_public_path__ + "static/media/Img3.2c087fc2.jpg";